export function toggleByRef<T>(item: T, list: T[]): T[] {
    return list.includes(item) ? list.filter((x) => x !== item) : [...list, item];
}


export function toggleByKey<T extends Record<string, any>>(item: T, list: T[], key: keyof T): T[] {
    return list.some((x) => x[key] === item[key])
        ? list.filter((x) => x[key] !== item[key])
        : [...list, item];
}